export default {
    title: "Auftrag im Namen von",
    model: {
        email: {
            label: "E-Mail",
            placeholder: "Bitte geben Sie Ihren Benutzernamen oder Ihre E-Mail-Adresse ein",
            notFound: "Benutzer nicht gefunden",
            errors: {
                myself: "Ihre E-Mail-Adresse muss sich von Ihrer unterscheiden"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Einreichen",
            processing: "Einreichen"
        }
    },
    error: {
        userNotExists: "{email} existiert nicht",
        country: {
            default: "OI ist im Benutzerland derzeit nicht verfügbar",
            ALPHA3: ""
        }
    }
}